import React from "react";
import PropTypes from "prop-types";
import InputGroupButtonDropdown from "reactstrap/lib/InputGroupButtonDropdown";

import { gatherClasses } from "../../lib/utils";
import DropdownTrigger from "../dropdown/DropdownTrigger";
import DropdownMenu from "../dropdown/DropdownMenu";

class InputGroupDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }

  toggle = () => {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
  };

  render() {
    const { addonType, size, direction } = this.props;
    const { isOpen } = this.state;
    return (
      <InputGroupButtonDropdown
        isOpen={isOpen}
        toggle={this.toggle}
        addonType={addonType}
        inNavbar
        size={size}
        direction={direction}
        className={gatherClasses(this.props, "oui-btn-droprown")}
      >
        <DropdownTrigger {...this.props} />
        <DropdownMenu {...this.props} />
      </InputGroupButtonDropdown>
    );
  }
}

InputGroupDropdown.propTypes = {
  label: PropTypes.string,
  split: PropTypes.bool,
  disabled: PropTypes.bool,
  disabledMain: PropTypes.bool,
  disabledTrigger: PropTypes.bool,
  onClick: PropTypes.func,
  onItemClick: PropTypes.func,
  rightAligned: PropTypes.bool,
  direction: PropTypes.oneOf(["down", "up"]),
  type: PropTypes.oneOf(["primary", "secondary"]),
  size: PropTypes.oneOf(["lg", "md", "sm"]),
  addonType: PropTypes.string,
  icon: PropTypes.shape({
    src: PropTypes.string,
    size: PropTypes.oneOf(["xs", "sm", "md", "lg"]),
    width: PropTypes.string,
    height: PropTypes.string,
    classes: PropTypes.string,
    onClick: PropTypes.func
  }),
  items: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
          .isRequired,
        disabled: PropTypes.bool,
        onClick: PropTypes.func
      }),
      PropTypes.shape({
        divider: PropTypes.bool
      }),
      PropTypes.shape({
        heading: PropTypes.string,
        items: PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
              .isRequired,
            disabled: PropTypes.bool,
            onClick: PropTypes.func
          })
        )
      })
    ])
  ).isRequired
};

InputGroupDropdown.defaultProps = {
  split: false,
  direction: "down",
  disabled: false,
  disabledMain: false,
  disabledTrigger: false,
  rightAligned: false,
  type: "primary",
  size: "md",
  addonType: "prepend"
};

InputGroupDropdown.displayName = "OrionInputGroupDropdown";

export default InputGroupDropdown;
